<mat-card class="admin-card">

  <div class="admin-header">

    <div class="results-badge">

      Results: {{ dataSource.data.length }}

    </div>

    <div class="admin-header-actions">

      <button mat-icon-button class="icon-btn-grey" (click)="getTickets()" matTooltip="Refresh tickets">
        <mat-icon>refresh</mat-icon>
      </button>

    </div>

  </div>

  <div class="admin-table-wrap">

    <table mat-table [dataSource]="dataSource" matSort class="admin-table">

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="actions-row">

            <button mat-icon-button (click)="openTicketDetails(element)" matTooltip="Open ticket details">
              <mat-icon>info_outline</mat-icon>
            </button>

          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="reference_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Ticket Number
        </th>

        <td mat-cell *matCellDef="let ticket">
          {{ ticket.reference_id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Type
        </th>

        <td mat-cell *matCellDef="let ticket">

          @if (ticket.type === 'bug') {
          <span class="tag red">
            Bug
          </span>
          }

          @if (ticket.type === 'feature') {
          <span class="tag green">
            Feature
          </span>
          }

          @if (ticket.type === 'question') {
          <span class="tag blue">
            Question
          </span>
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Subject
        </th>

        <td mat-cell *matCellDef="let ticket">
          {{ ticket.subject }}
        </td>
      </ng-container>

      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          User
        </th>

        <td mat-cell *matCellDef="let ticket">
          {{ getUserName(ticket.user) | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="resolved_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Status
        </th>

        <td mat-cell *matCellDef="let ticket">

          @if (ticket.resolved_at) {
          <span class="tag green">
            Resolved
          </span>
          } @else {
          <span class="tag yellow">
            Open
          </span>
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="age_human">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Created
        </th>

        <td mat-cell *matCellDef="let ticket">
          {{ ticket.age_human }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="admin-row">
      </tr>

    </table>

    <mat-paginator class="admin-paginator" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>

  </div>

</mat-card>